








































































































import { Component, Mixins, Inject, Prop } from "vue-property-decorator";

// Mixins
import ClientMixin from "@/mixins/clientMixin";

// Types
import { ITicket } from "@/models/tickets";
import { TicketStatusMap } from "@/data/enums/tickets";
import {
  ITicketsProvider,
  ITicketsProviderMethods
} from "@/models/providers/tickets";
import { IStatus } from "@/models/statuses";

@Component({
  components: {
    "tickets-inbox-item-template": () =>
      import("@/components/app/global/tickets/ticketsInboxItemTemplate.vue"),
    "ticket-status-dropdown": () =>
      import("@/components/app/global/tickets/ticketStatusDropdown.vue")
  }
})
export default class InboxListItem extends Mixins(ClientMixin) {
  // Inject

  @Inject({ from: "ticketsProvider" })
  public readonly $ticketsProvider!: () => ITicketsProvider;

  public get ticketsProvider() {
    return this.$ticketsProvider();
  }

  @Inject({ from: "ticketsProviderMethods" })
  public readonly $ticketsMethods!: ITicketsProviderMethods;

  // Props

  @Prop({ required: true })
  public readonly ticket!: ITicket;

  @Prop({ default: "updated_at" })
  public dateField!: "updated_at" | "created_at";

  // Methods

  public isProcessing = false;

  public async changeStatus(statusId: IStatus["id"]) {
    if (this.isProcessing) return;

    try {
      this.isProcessing = true;
      await this.$ticketsMethods.changeTicketStatus(statusId, this.ticket.id);
      await this.$ticketsMethods.refreshInbox();

      this.$store.dispatch("toast/show", {
        message: this.$t("_sentence.ticket.status_changed")
      });
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
    } finally {
      this.isProcessing = false;
    }
  }

  // Computed

  public get mappedStatus() {
    return this.$_.get(TicketStatusMap(), this.ticket.status.code);
  }
}
